'use client'

const MONO: React.CSSProperties = { fontFamily: 'var(--font-mono)', fontWeight: 500 }

const POSITIONS = [
  { x: 60, y: 60 },
  { x: 200, y: 60 },
  { x: 60, y: 200 },
  { x: 200, y: 200 }
] as const

const THUMBS = [
  { id: 'IMG_0421', color: 'var(--mauve)' },
  { id: 'IMG_0422', color: 'var(--sky)' },
  { id: 'IMG_0423', color: 'var(--yellow)' },
  { id: 'IMG_0424', color: 'var(--acid)' }
] as const

export function GalleryBody({ phase }: { phase: number }) {
  const segs = POSITIONS.length
  const stepIdx = Math.floor(phase * segs) % segs
  const local = phase * segs - Math.floor(phase * segs)
  const pos = POSITIONS[stepIdx]
  const clicking = local > 0.7

  const picked = [phase > 0.05, phase > 0.3 && phase < 0.55, phase > 0.55, false]

  return (
    <div style={{ padding: 18, position: 'relative', minHeight: 320 }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12 }}>
        {THUMBS.map((t, i) => (
          <div
            key={t.id}
            style={{
              border: '2.5px solid var(--ink)',
              position: 'relative',
              background: t.color,
              aspectRatio: '4/3',
              boxShadow: picked[i] ? 'var(--shadow)' : 'var(--shadow-sm)',
              transform: picked[i] ? 'translate(-1px, -1px)' : 'none',
              transition: 'all .15s'
            }}>
            <svg
              width="100%"
              height="100%"
              style={{ display: 'block' }}
              preserveAspectRatio="none"
              viewBox="0 0 100 75"
              aria-hidden>
              <defs>
                <pattern
                  id={`proof-pat-${i}`}
                  width={6}
                  height={6}
                  patternUnits="userSpaceOnUse"
                  patternTransform="rotate(45)">
                  <line x1={0} y1={0} x2={0} y2={6} stroke="rgba(10,10,10,0.18)" strokeWidth={2} />
                </pattern>
              </defs>
              <rect width={100} height={75} fill={`url(#proof-pat-${i})`} />
            </svg>
            <div
              style={{
                position: 'absolute',
                top: 6,
                left: 6,
                background: 'var(--ink)',
                color: 'var(--paper)',
                padding: '2px 6px',
                fontFamily: 'var(--font-mono)',
                fontSize: 9,
                fontWeight: 700,
                letterSpacing: '0.1em'
              }}>
              {t.id}
            </div>
            <div
              style={{
                position: 'absolute',
                bottom: 6,
                right: 6,
                width: 26,
                height: 26,
                border: '2px solid var(--ink)',
                background: picked[i] ? 'var(--hot)' : 'var(--paper)',
                display: 'grid',
                placeItems: 'center',
                transition: 'background .15s',
                transform: picked[i] && stepIdx === i && clicking ? 'scale(1.15)' : 'scale(1)'
              }}>
              <svg
                width={14}
                height={14}
                viewBox="0 0 24 24"
                fill={picked[i] ? 'var(--paper)' : 'none'}
                stroke="var(--ink)"
                strokeWidth={2.5}
                aria-hidden>
                <path d="M12 21s-7-4.5-9.5-9C.5 8 3 4 7 4c2 0 3.5 1 5 3 1.5-2 3-3 5-3 4 0 6.5 4 4.5 8C19 16.5 12 21 12 21z" />
              </svg>
            </div>
          </div>
        ))}
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: 12,
          left: 18,
          right: 18,
          border: '2px solid var(--ink)',
          background: 'var(--yellow)',
          padding: '8px 12px',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          boxShadow: 'var(--shadow-sm)'
        }}>
        <span style={{ ...MONO, fontSize: 10, fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase' }}>
          Note on IMG_0423
        </span>
        <span style={{ ...MONO, fontSize: 11, flex: 1, opacity: 0.85 }}>&quot;Crop tighter on this one&quot;</span>
      </div>

      <div
        aria-hidden
        style={{
          position: 'absolute',
          left: pos.x + 90,
          top: pos.y + 80,
          pointerEvents: 'none',
          transition: 'left .35s ease-out, top .35s ease-out',
          zIndex: 10
        }}>
        <svg width={16} height={20} viewBox="0 0 18 22" fill="var(--ink)" stroke="var(--paper)" strokeWidth={1.5}>
          <path d="M2 2 L2 18 L6 14 L9 20 L11 19 L8 13 L14 13 Z" />
        </svg>
      </div>
    </div>
  )
}
